import React from 'react';
import PropTypes from "prop-types";
import { Modal, ModalSize } from 'components/notifications';
import { Intent } from '@blueprintjs/core';
import { Key } from 'components/key';
import './CalendarKeyModal.css';
import { GridLayout } from 'components/grid';

export function CalendarKeyModal(
    {
        showKeyModal = false,
        closeKeyModal = () => { },
        isInitialising = false,
        activityTypesForKeyModal = [],
        calendarIconsForKeyModal = []
    }
) {
    return (
        <Modal
            isOpen={showKeyModal}
            clickOutsideClose
            onClose={closeKeyModal}
            title="Key"
            icon="warning-sign"
            intent={Intent.DANGER}
            confirmButtonText="Dismiss"
            onConfirm={closeKeyModal}
            className="calendar-key-modal"
            size={ModalSize.SMALL}
        >
            <div>
                <GridLayout numberOfColumns={2}>
                    <div>
                        <h5 className="key">Activity Types</h5>
                        <Key listVertical loading={isInitialising} items={activityTypesForKeyModal} />
                    </div>
                    <div className='spacer-bottom-small'>
                        <h5 className="key">Calendar Icons</h5>
                        <Key rounded listVertical loading={isInitialising} items={calendarIconsForKeyModal} hideBorder={true} />
                    </div>
                </GridLayout>
            </div>
        </Modal>
    );
}


CalendarKeyModal.propTypes = {
    showKeyModal: PropTypes.bool,
    closeKeyModal: PropTypes.func,
    isInitialising: PropTypes.bool,
    activityTypesForKeyModal: PropTypes.array.isRequired,
    calendarIconsForKeyModal: PropTypes.array.isRequired
};